/**
 * Logger Utility - Logging condicional para desenvolvimento e produção
 * 
 * Em desenvolvimento: Todos os logs são exibidos no console
 * Em produção: Logs são suprimidos ou enviados para serviço externo
 * 
 * Uso:
 * import { logger } from '@/utils/logger';
 * logger.log('[Feature] Mensagem');
 * logger.error('[Feature] Erro', error);
 */

const isDev = import.meta.env?.DEV ?? false;

export const logger = {
    /**
     * Log de informações gerais (equivalente a console.log)
     * Exibido apenas em desenvolvimento
     */
    log: (...args: any[]) => {
        if (isDev) {
            console.log(...args);
        }
    },

    /**
     * Log de erros (equivalente a console.error)
     * Em produção, deveria enviar para Sentry/Firebase Crashlytics
     */
    error: (...args: any[]) => {
        if (isDev) {
            console.error(...args);
        } else {
            // TODO FASE 4: Integrar com Sentry ou Firebase Crashlytics
            // Exemplo: Sentry.captureException(args[0]);
            // Por ora, silencioso em produção
        }
    },

    /**
     * Log de avisos (equivalente a console.warn)
     * Exibido apenas em desenvolvimento
     */
    warn: (...args: any[]) => {
        if (isDev) {
            console.warn(...args);
        }
    },

    /**
     * Log de informações (equivalente a console.info)
     * Exibido apenas em desenvolvimento
     */
    info: (...args: any[]) => {
        if (isDev) {
            console.info(...args);
        }
    },

    /**
     * Log de debug (equivalente a console.debug)
     * Exibido apenas em desenvolvimento
     */
    debug: (...args: any[]) => {
        if (isDev) {
            console.debug(...args);
        }
    },

    /**
     * Log de tabela (equivalente a console.table)
     * Útil para exibir arrays/objetos em formato tabular
     */
    table: (data: any) => {
        if (isDev) {
            console.table(data);
        }
    }
};

// Export default para importação simplificada
export default logger;
